<template>
  <div class="radio-group">
    <ui-radio
      v-for="(option, i) in options"
      :key="i"
      v-model="selected"
      :option="option.value"
      :label="option.label"
      :name="name"
      :error="errorMode"
    />
  </div>
</template>

<script>
export default {
  name: 'radio-group',
  props: {
    value: {
      type: String,
      default: ''
    },

    options: {
      type: Array,
      required: true,
    },

    name: {
      type: String,
      required: true
    },

    errorMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    selected: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val)
      }
    },
  },
};
</script>

<style lang="scss">
.radio-group {
  .ui-radio {
    margin-top: 16px;
  }
}
</style>